import { useRef, useLayoutEffect, useEffect, useState } from 'react';
import moment from 'moment-timezone';
import Browser from './getBrowserInfo';
import cogoToast from 'cogo-toast';
import '../assets/styles/toast.scss';



export function useWindowSize() {
    const isClient = typeof window === 'object';

    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined,
        };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
        if (!isClient) {
            return false;
        }

        function handleResize() {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return windowSize;
}

const getUserOS = () => {
    let OSName = "Unknown";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") !== -1) OSName = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") !== -1) OSName = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") !== -1) OSName = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") !== -1) OSName = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") !== -1) OSName = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") !== -1) OSName = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") !== -1) OSName = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") !== -1) OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") !== -1) OSName = "Linux";
    return OSName;
}

const getUserBrowser = () => Browser.name;

const getUserBrowserVersion = () => Browser.version;

const getUserTimeZone = () => moment.tz.guess(true);

const getPlatform = () => "Dashboard";

const convertToBinary = base64 => {
    return new Promise(resolve => {
        let byteString;
        if (base64.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(base64.split(',')[1]);
        else
            byteString = unescape(base64.split(',')[1]);
        let mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const result = new Blob([ia], { type: mimeString });
        resolve(result);
    });
}

const getProgress = (ordered, building) => {
    ordered = parseInt(ordered);
    building = parseInt(building);
    if (ordered === 0) return 0;
    else if ((ordered - building) > 0) return Math.ceil(((building * 100) / ordered));
    else return 100;
}


const getComplete = (ordered, building, buildingOverflow) => {//For Outer Stats
    ordered = parseInt(ordered);
    building = parseInt(building);
    if (ordered === 0) return 0;
    else if ((ordered - building + buildingOverflow) > 0) return Math.ceil((((building - buildingOverflow) * 100) / ordered));
    else return 100;
}

// ordered: 0
// isp: 0
// enroute: 0
// building: 

/**
   - The Formula is
   - if (quantity at ISP + quantity at Enroute + uqantity at Building) > Ordered Quantity
    then
    (quantity at ISP + quantity at Enroute + Quantity at Building) - Ordered Quantity 
 */

const getOverflow = (ordered, building, isp, enroute) => {
    ordered = parseInt(ordered);
    building = parseInt(building);
    enroute = parseInt(enroute);
    isp = parseInt(isp);
    if ((isp + enroute + building) > ordered) return ((isp + enroute + building) - ordered);
    else return 0;
}

export function validateEmail(email) {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(email).toLowerCase());
}

export const browserNames = (function () {
    var ua = window.navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
})();

export const browser = (function () {
    var test = function (regexp) {
        return regexp.test(window.navigator.userAgent);
    }
    switch (true) {
        case test(/edg/i): return "edge";
        case test(/opr/i) && (!!window.opr || !!window.opera): return "opera";
        case test(/chrome/i) && !!window.chrome: return "chrome";
        case test(/trident/i): return "ie";
        case test(/firefox/i): return "firefox";
        case test(/safari/i): return "safari";
        default: return "other";
    }
})();

const deserialize = (str) => {   // this will Serialize JSON   


    let data = ''
    let arr = []
    if (str != "" && str != undefined) {
        arr = str.split('&&')



        data = arr.map(key => {
            let temp = key.split(',')
            if (temp[0].includes("%2B")) {
                let rep = temp[0].replace(/%2B/g, "+")
                temp[0] = rep
            }
            if (temp[0].includes("%20")) {
                let rep = temp[0].replace(/%20/g, ' ')
                temp[0] = rep
            }
            if (temp[0].includes("%40")) {
                let resp = temp[0].replace(/%40/g, "@")
                temp[0] = resp
            }
            if (temp[0].includes("%3A")) {
                let resp = temp[0].replace(/%3A/g, ":")
                temp[0] = resp
            }
            if (temp[0].includes("?")) {
                let resp = temp[0].replace('?', '')
                temp[0] = resp
            }

            return temp.join(',')
        })
    }
    return data

}

const serialize = (arr) => {
    var str = [];
    str = arr.map(key => {
        return `${key.value},${key.route}`
    })
    return str.join("&&");
}

export function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

const ranges = [
    { divider: 1e18, suffix: 'E' },
    { divider: 1e15, suffix: 'P' },
    { divider: 1e12, suffix: 'T' },
    { divider: 1e9, suffix: 'G' },
    { divider: 1e6, suffix: 'M' },
    { divider: 1e3, suffix: 'k' },
];

function formatNumber(n) {
    if (n < 0) {
        return `-${formatNumber(-n)}`;
    }
    for (let i = 0; i < ranges.length; i += 1) {
        if (n >= ranges[i].divider) {
            return (n / ranges[i].divider).toFixed(2).toString() + ranges[i].suffix;
        }
    }
}

function getNotification(type, message, position, hideAfter) {
    let options = {
        hideAfter: hideAfter ? hideAfter : 5,
        position: position ? position : 'top-right',
    };
    switch (type) {
        case 'success':
            return cogoToast.success(message, options);
        case 'info':
            return cogoToast.info(message, options);
        case 'loading':
            return cogoToast.loading(message, options);
        case 'warn':
            return cogoToast.warn(message, options);
        case 'error':
            return cogoToast.error(message, options);
    }
}
export default {
    getUserOS,
    getUserBrowser,
    getUserBrowserVersion,
    getUserTimeZone,
    getPlatform,
    getProgress,
    getComplete,
    getOverflow,
    deserialize,
    serialize,
    isEmpty,
    convertToBinary,
    formatNumber,
    getNotification
}